import updateDocumentData from "../../utils/updateDocumentData";

import { DiscussionChannel } from "./types/DiscussionChannel";

export default function updateDiscussionChannel(firebase, ref, data) {
	return ref.set(DiscussionChannel.partial().parse(updateDocumentData(firebase, data)), { merge: true });
}
